import bus from './eventbus'

function openToast(opts) {
  // Ensure text is always a string to avoid [object Object] display issues
  if (opts.text && typeof opts.text === 'object') {
    console.warn('Toast text was an object, converting to string:', opts.text)
    try {
      opts.text = JSON.stringify(opts.text)
    } catch (e) {
      opts.text = 'An error occurred'
    }
  }
  bus.emit('toast:open', opts)
}

// Create toast object
const toast = {
  open: openToast,
  closeAll: () => bus.emit('toast:close-all'),
  error: (text, opts) => {
    // Ensure text is a string
    const safeText = typeof text === 'object' ? JSON.stringify(text) : String(text)
    return openToast({
      text: safeText,
      ...opts,
      props: {
        color: 'red25 text-red600',
        timeout: 4e3,
        ...opts?.props,
      },
    })
  },
  info: (text, opts) => {
    // Ensure text is a string
    const safeText = typeof text === 'object' ? JSON.stringify(text) : String(text)
    return openToast({
      text: safeText,
      ...opts,
      props: {
        color: 'blue25 text-blue600',
        ...opts?.props,
      },
    })
  },
  success: (text, opts) => {
    // Ensure text is a string
    const safeText = typeof text === 'object' ? JSON.stringify(text) : String(text)
    return openToast({
      text: safeText,
      ...opts,
      props: {
        color: 'lime25 text-lime600',
        ...opts?.props,
      },
    })
  },
}

// Setup function for Vue 3
export const setupToasts = app => {
  app.config.globalProperties.$toast = toast
}

export default toast
